export const platforms = {
  window: 'window',
  mac: 'mac',
  linux: 'linux',
}